/* eslint-disable max-len */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useLocalisation } from '@3plearning/lingui-cdn';
import { Button } from '@3plearning/react-components';

import { DISMISS_MODAL } from '@containers/modal-manager/modal-manager-actions';
import { AllAssigned } from '@helpers/icon-dictionary';

import SvgIcon from '@components/svg-icon/svg-icon';
import useManageAssignments from "../../helpers/hooks/use-manage-assignments";
import { selectIsAssigningOrUnAssigning } from "../footer/selectors";
import AssignmentsSummary from './components/assignments-summary//assignments-summary'
import AssignedList from './assign-list';
import {
  getStudentAssignments,
  resetAssignments
} from './redux/actions';
import {
  CourseDetails,
  ModalBody,
  Footer,
  ResultsWrapper,
  StudentDetails,
  StudentName,
  TabHeading
} from './styled';

const CurrentAssignmentsModal = props => {
  const {
    student: { id: studentProfileId, firstName, lastName },
    selectedClass: { label: classText }
  } = props;

  const studentFullName = `${firstName} ${lastName}`;

  const dispatch = useDispatch();
  const { i18n } = useLocalisation();

  const isAssigningOrUnAssigning = useSelector(selectIsAssigningOrUnAssigning);
  const assignments = useSelector(state => state.currentAssignmentsModalReducer.assignments);
  const selectedAssignmentIds = useSelector(state => state.currentAssignmentsModalReducer.selectedAssignmentIds);
  const selectedProduct = useSelector(state => state.product, shallowEqual);

  const { unassignAssignments } = useManageAssignments();

  useEffect(() => {
    dispatch(resetAssignments());
  }, []);

  useEffect(() => {
    dispatch(getStudentAssignments(studentProfileId, selectedProduct.id));
  }, [studentProfileId]);

  const getToastText = (studentUnAssignments) => {
    const i18nMessage = i18n.t`Activities are unassigned from this student`;

    return `(${studentUnAssignments.length}) ${i18nMessage} (${studentFullName})`
  }

  const handleUnassignAssignments = async () => {
    const studentUnAssignments = selectedAssignmentIds.map(assignmentId => {
      const selectedAssignment = assignments.find((assignment) => assignment.assignmentId === assignmentId);
      return {
        studentUserProfileId: studentProfileId,
        assignmentId,
        learningJourneyId: selectedAssignment.learningJourneyId
      }
    });

    await unassignAssignments(studentUnAssignments, getToastText(studentUnAssignments));
    dispatch({ type: DISMISS_MODAL });
    dispatch(resetAssignments());
  };
  const currentlyAssignedAssignmentsCount = assignments.filter(assignment => !assignment.currentAssignmentUnavailableForStudent).length;
  return (
    <ModalBody>
      <StudentDetails>
        <StudentName>{`${studentFullName}`}</StudentName>
        <CourseDetails>{classText}</CourseDetails>
      </StudentDetails>
      <AssignmentsSummary currentlyAssignedAssignmentsCount={currentlyAssignedAssignmentsCount} totalAssignments={assignments.length}/>
      <TabHeading>
        <SvgIcon icon={AllAssigned} />
        {i18n.t`Assigned (${currentlyAssignedAssignmentsCount})`}
      </TabHeading>

      <ResultsWrapper>
        <AssignedList />
      </ResultsWrapper>

      <Footer>
        <div />

        <Button
          className="unassign"
          disabled={selectedAssignmentIds.length === 0 || isAssigningOrUnAssigning}
          onClick={handleUnassignAssignments}
          primary
          text={i18n.t`Unassign`}
          type={Button.LOZENGE}
        />

        <Button primary text={i18n.t`OK`} type={Button.LOZENGE} onClick={() => dispatch({ type: DISMISS_MODAL })} />
      </Footer>
    </ModalBody>
  );
};

CurrentAssignmentsModal.defaultProps = {
  class: {},
  selectedClass: {}
};

CurrentAssignmentsModal.propTypes = {
  student: PropTypes.object,
  selectedClass: PropTypes.object
};

export function viewCurrentAssignmentsModal(student, selectedClass) {
  return {
    content: <CurrentAssignmentsModal student={student} selectedClass={selectedClass} />,
    id: 0,
    buttons: []
  };
}

export default CurrentAssignmentsModal;
